// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3QGkI"};